import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverlastDagboek = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F29FC5"
      d="M25.4 23.21V33H14.59v-9.79c0-2.98 2.42-5.4 5.4-5.4s5.4 2.42 5.4 5.4zM31.4 11.89l-1.7-.68-1.51.6-.38-.93 1.89-.75 1.7.68 1.7-.68 1.88.75-.37.93-1.51-.6zM34.58 8.48l-.9-.8-1.39-.02-1.04-.92-1.21-.01.01-1 1.58.01 1.05.93 1.39.01 1.17 1.05zM30.56 16.59l-.67-.74 1.15-1.05 1.38-.04 1.01-.93 1.56-.04.03 1-1.19.03-1.01.93-1.38.04zM20 17.8A5.4 5.4 0 1 0 20 7a5.4 5.4 0 0 0 0 10.8"
    />
    <mask
      id="Overlast_dagboek_svg__a"
      width={12}
      height={11}
      x={14}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M20 17.8A5.4 5.4 0 1 0 20 7a5.4 5.4 0 0 0 0 10.8"
      />
    </mask>
    <g mask="url(#Overlast_dagboek_svg__a)">
      <path
        fill="#fff"
        d="M25.89 15.92h-1c0-1.46-1.19-2.65-2.65-2.65s-2.65 1.19-2.65 2.65h-1c0-2.01 1.64-3.65 3.65-3.65s3.65 1.64 3.65 3.65"
      />
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverlastDagboek);

export default ForwardRef;
